module.exports = __webpack_public_path__ + "static/img/yinliLogo.c424bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yinliLogo.png
// module id = gzKr
// module chunks = 68